import englishTranslation from './en.json';
import dutchTranslation from './nl.json';

const translations = {
	...englishTranslation,
	...dutchTranslation,
}

export default translations;
